import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledTooltip = styled.div`
    background-color: #000;
    border-radius: 2px;
    color: #fff;
    display: flex;
    font-family: 'Inter UI', sans-serif;
    font-size: 9px !important;
    font-weight: 600;
    justify-content: center;
    padding: 4px 8px;
    position: absolute;
    top: -20px;

    ${({theme}) => theme.media.desktop}{
        bottom: -30px;
        top: initial;
    }

    &::before {
        position: absolute;
        top: -5px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 4px 5px 4px;
        border-color: transparent transparent #000 transparent;

        ${({theme}) => theme.media.desktop}{
            content:'';
        }        
    }
`;

const Tooltip = ({message}) => (
    <StyledTooltip>
        { message }
    </StyledTooltip>
);

Tooltip.propTypes = {
    message:PropTypes.string.isRequired
}

export default Tooltip;